import Image from "next/image";
import style from "./HorizontalScroll.module.scss";
import { scrollData } from "../landingData";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay, Keyboard } from "swiper";
import "swiper/css";
import "swiper/css/effect-coverflow";

const HorizontalScroll = ({ dictionary }) => {
	return (
		<section className={style.section}>
			<div className={style.swiperBlock}>
				<h2 className={style.title}>{dictionary["page_editor_block3_header"] || "Why choose BgRem AI photo editor?"}</h2>
				<Swiper
					effect={"coverflow"}
					slidesPerView="auto"
					spaceBetween={250}
					loop={true}
					centeredSlides={true}
					autoplay={{ delay: 3000, disableOnInteraction: false }}
					keyboard={{
						enabled: true,
					}}
					coverflowEffect={{
						rotate: 0,
						depth: 100,
						modifier: 1,
						slideShadows: false,
					}}
					breakpoints={{
						1921: {
							slidesPerView: 2,
							spaceBetween: 100,
						},
						1200: {
							slidesPerView: 2,
							spaceBetween: 100,
						},
						1024: {
							slidesPerView: 2,
							spaceBetween: 100,
						},
						769: {
							slidesPerView: 2,
							spaceBetween: 50,
						},
						481: {
							slidesPerView: 1.2,
							spaceBetween: 50,
						},
						320: {
							slidesPerView: 1,
						},
					}}
					modules={[EffectCoverflow, Autoplay, Keyboard]}
				>
					{scrollData.map((item) => {
						return (
							<SwiperSlide key={item.title}>
								<div key={item.id} className={style.item}>
									<p className={style.text}>{dictionary[item.dicTitle] || item.title}</p>
									<div className={style.imageWrapper}>
										<Image className={style.image} src={item.imageUrl} alt="Editor preview" width={668} height={469} quality={90} loading="lazy" />
									</div>
								</div>
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
			<div className={style.wrapper}>
				<div className={style.sticky}>
					<h2 className={style.title}>{dictionary["page_editor_block3_header"] || "Why choose BgRem AI photo editor?"}</h2>
					<div className={style.container}>
						<div className={style.scroll}>
							{scrollData.map((item) => (
								<div key={item.id} className={style.item}>
									<p className={style.text}>{dictionary[item.dicTitle] || item.title}</p>
									<div className={style.imageWrapper}>
										<Image className={style.image} src={item.imageUrl} alt="Editor preview" width={668} height={469} />
									</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default HorizontalScroll;
